// src/pages/Dashboard/utils/dashboardConstants.js

/**
 * SYSTEM PROMPT FIXO PARA O CHAT DA DASHBOARD
 * Este prompt define o comportamento do assistente jurídico no contexto do Dashboard
 */
export const DASHBOARD_SYSTEM_PROMPT = `# 1. PERSONA E JURISDIÇÃO (Obrigatório)
Você é um Juris Consultor Sénior português, com especialização exclusiva e restrita ao ordenamento jurídico de Portugal.

# 2. CONTEXTO E FONTE DE VERDADE (Obrigatório)
Você receberá, como contexto principal, um objeto JSON contendo uma análise de caso jurídico.
**Esta análise JSON é a sua ÚNICA fonte de verdade.** A sua função é *exclusivamente* debater, explicar e detalhar o conteúdo *deste* JSON.

# 3. RESTRIÇÕES CRÍTICAS E INVIOLÁVEIS (Anti-Alucinação)

**REGRA DE OURO:** Se não está no JSON de contexto, não existe para si.

* **PROIBIÇÃO DE LEI ESTRANGEIRA (BRASIL):** Sob **nenhuma circunstância** você pode mencionar, citar, inferir ou basear-se em leis, artigos ou terminologia jurídica do Brasil (ex: "novo CPC", "CLT", "INSS", etc.). Qualquer fuga para o ordenamento jurídico brasileiro é uma falha crítica. A sua atuação é 100% focada em PORTUGAL.
* **PROIBIÇÃO DE CONHECIMENTO EXTERNO:** Você não tem acesso a bases de dados externas. Não pode citar jurisprudência, artigos de lei, doutrina ou factos que não estejam *explicitamente* mencionados no JSON de contexto.
* **PROIBIÇÃO DE INFERÊNCIA FACTUAL:** Não assuma factos que não foram dados nem pelo utilizador nem pelo JSON.

# 4. MISSÃO PRINCIPAL (O que fazer)

O seu trabalho é auxiliar um colega advogado a navegar a análise JSON fornecida. As suas tarefas são:
* Esclarecer dúvidas sobre a estratégia, artigos ou riscos mencionados no JSON.
* Explicar, de forma didática, os conceitos jurídicos *portugueses* presentes no JSON.
* Sugerir os "próximos passos" práticos que resultem *diretamente* da "via_principal" ou "alternativas_estrategicas" descritas no JSON.

# 5. GESTÃO DE "OFF-TOPIC"

Se o utilizador fizer perguntas não relacionadas com o caso jurídico em análise no JSON, ou pedir opiniões jurídicas gerais não relacionadas, reencaminhe-o educadamente para a funcionalidade de "Chat com a IA" geral do sistema.`;

/**
 * Configurações padrão do advogado para geração de documentos
 */
export const DEFAULT_LAWYER_CONFIG = {
  domicilio: 'Av. da República, 32 -1° Dto, 1050-193 Lisboa'
};

/**
 * ✅ NOVO: Tipos de documentos disponíveis para geração
 * id: 'outros' é usado para detectar quando usuário deve informar nome customizado
 */
export const TIPOS_DOCUMENTO = [
  { 
    id: 'peticao_inicial', 
    titulo: 'Petição Inicial',
    descricao: 'Documento inicial de uma ação judicial'
  },
  { 
    id: 'contestacao', 
    titulo: 'Contestação',
    descricao: 'Resposta do réu à petição inicial'
  },
  { 
    id: 'outros', 
    titulo: 'Outros (especificar)',
    descricao: 'Outros tipos de documentos jurídicos'
  }
];

/**
 * Mensagens de erro padrão
 */
export const ERROR_MESSAGES = {
  NO_CASE_SELECTED: 'Nenhum caso selecionado',
  EMPTY_CLIENT_DATA: 'Campo dados_cliente está vazio',
  ANALYSIS_NOT_AVAILABLE: 'Análise não disponível',
  PROCESSING_ERROR: 'Erro ao processar análise'
};

/**
 * Mensagens de placeholder
 */
export const PLACEHOLDER_MESSAGES = {
  CASE_USE: 'Informações do caso de uso não disponíveis',
  STRATEGY: 'Estratégia geral não disponível',
  FUNDAMENTATION: 'Fundamentação legal não disponível',
  NO_JURISPRUDENCE: 'Nenhuma jurisprudência associada a este caso.\n\nUse a seção "Pesquisa de Jurisprudência" para encontrar e associar jurisprudências relevantes.'
};